export const keys = <T extends Record<string, unknown>, K extends keyof T>(
  obj: T
): K[] => Object.keys(obj) as K[];
